import { motion } from "framer-motion";
import "../styles/aboutus.css";

function AboutUs() {
  return (
    <section id="about" className="container-fluid about-section">
      <div className="container">
        <motion.h2
          className="about-title pt-5"
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          Miért érdemes rám hallgatnod? Ki vagyok én valójában?
        </motion.h2>

        <div className="row align-items-center px-3">
          <motion.div
            className="col-md-5 pe-lg-5 pb-sm-5 pb-4 text-center"
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <img
              src="images/aboutme.webp"
              alt="FRDYPromotions – Rólam: tapasztalt kisvállalkozói online marketing tanácsadó"
              className="about-image"
              loading="lazy"
            />
          </motion.div>

          <motion.div
            className="col-md-7"
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <p className="about-text">
              Én mindig azokra hallgatok, akik már végigmentek azon az úton,
              amin én is járni szeretnék – és ugyanezt javaslom neked is. Azért
              merek más kisvállalkozásoknak tanácsot adni az online
              hirdetéseikkel kapcsolatban, mert nem csupán „marketingtanácsadó”
              vagyok. Én is vállalkozóként indultam, és a saját bőrömön
              tapasztaltam meg, hogyan lehet a hirdetések segítségével stabil
              bevételt, növekedést és akár szabadabb életet is elérni.
            </p>
            <p className="about-text">
              2018 óta építem a{" "}
              <strong>
                <a
                  href="https://pizzahomeszolnok.hu/"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="about-link"
                >
                  Pizza Home
                </a>
              </strong>{" "}
              nevű pizzériámat Szolnokon, amely mára a város harmadik
              legforgalmasabb pizzériájává nőtte ki magát. 2024-től már
              franchise-ként is működünk{" "}
              <strong>
                <a
                  href="https://pizzaeger.hu/"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="about-link"
                >
                  Egerben
                </a>
              </strong>
              . A marketinget kezdettől fogva saját kezemben tartottam, és
              pontosan tudom, milyen érzés az, amikor egy jól célzott kampány
              „néhány” új ügyfelet hoz – ami viszont egész családok életét képes
              megváltoztatni.
            </p>
            <p className="about-text">
              Ma már nemcsak a saját vállalkozásomat építem, hanem más
              kisvállalkozásoknak is segítek, hogy online hirdetéseikkel több
              ügyfelet, magabiztosabb működést, és nagyobb szabadságot érjenek
              el.
            </p>
            <p className="about-text">
              Ha te is szeretnél olyan vállalkozást, ami nemcsak megélhetést,
              hanem anyagi biztonságot és szabadidőt is ad, akkor keress bátran
              – szívesen segítek elindulni ezen az úton.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Curved Divider */}
      <div className="curved-divider-about">
        <svg viewBox="0 0 1440 100" preserveAspectRatio="none">
          <path
            fill="#2C2F36"
            d="M0,70 C90,100 1080,0 1440,70 L1440,100 L0,100 Z"
          />
        </svg>
      </div>
    </section>
  );
}

export default AboutUs;
